import classNames from 'classnames'

import { ICON_HEIGHT_28, IconNG } from '../../../Icon'

import * as styles from './DashboardTileBadge.module.css'

function DashboardTileBadge({ Icon, tone }) {
  return (
    <IconNG
      Icon={Icon}
      className={classNames(styles.badge, styles[tone])}
      size={ICON_HEIGHT_28}
    />
  )
}

export default DashboardTileBadge
